import { render, staticRenderFns } from "./my-template.vue?vue&type=template&id=5b369f92&scoped=true&"
import script from "./my-template.vue?vue&type=script&lang=js&"
export * from "./my-template.vue?vue&type=script&lang=js&"
import style0 from "./my-template.vue?vue&type=style&index=0&id=5b369f92&lang=scss&scoped=true&"
import style1 from "./my-template.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b369f92",
  null
  
)

export default component.exports